/**
 * Meta Pixel helpers.
 *
 * Pixel ID: 3524371057739219
 * Base code is installed in public/index.html (fires the initial PageView).
 * These helpers fire standard + custom events from the SPA, since
 * react-router route changes do not reload the document.
 */

const META_PIXEL_ID = '3524371057739219';

function getFbq() {
  if (typeof window === 'undefined') return null;
  if (typeof window.fbq === 'function') return window.fbq;
  return null;
}

/**
 * Track a standard Meta Pixel event (e.g. 'CompleteRegistration', 'Purchase').
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackMetaEvent(eventName, params = {}) {
  if (process.env.NODE_ENV !== 'production') return;
  const fbq = getFbq();
  if (!fbq) return;
  try {
    fbq('track', eventName, params);
  } catch (err) {
    console.warn(`[Meta Pixel] "${eventName}" failed:`, err);
  }
}

/**
 * Track a custom Meta Pixel event defined in Events Manager.
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackMetaCustom(eventName, params = {}) {
  if (process.env.NODE_ENV !== 'production') return;
  const fbq = getFbq();
  if (!fbq) return;
  try {
    fbq('trackCustom', eventName, params);
  } catch (err) {
    console.warn(`[Meta Pixel] custom "${eventName}" failed:`, err);
  }
}

/**
 * Fire PageView for SPA navigations (the pixel only auto-fires PageView
 * on a full document load).
 */
export function trackMetaPageView() {
  trackMetaEvent('PageView');
}

export { META_PIXEL_ID };
